module.exports = __webpack_public_path__ + "static/media/kitchen-island.bc37fded.svg";